import {useContext} from 'react';
import PositionContextMobile from '../contextCreate/PositionContextMobile';

const usePosition = () => useContext(PositionContextMobile);

export default usePosition;
